import React from "react";
// import home3 from '../images/home3.png';
import safety from "../assets/safet.jpg"
// import N3060 from '../images/N3060.mp4'

const FireSafetySection = () => {
  // const [isVideoOpen, setIsVideoOpen] = useState(false);

  return (
    <div className="relative w-full h-screen overflow-hidden">
      {/* Background Image (fixed) */}
      <div
        className="absolute top-0 left-0 w-full h-full bg-cover bg-center bg-no-repeat lg:ml-32"
        style={{
          backgroundImage: `url(${safety})`, 
          backgroundAttachment: "fixed",
        }}
      />

      {/* Overlay for dark effect */}
      <div className="absolute top-0 left-0 w-full h-full" />

      {/* Content (scrollable text) */}
      <div className="relative z-10 flex flex-col h-full justify-center px-6 lg:px-20 mt-0 lg:mt-16 ml-0 lg:ml-20 items-center lg:items-start">
        <div className="bg-green-600 text-white p-6 rounded-xl w-full max-w-md shadow-lg">
          <h2 className="text-xl md:text-2xl font-semibold mb-4">
            Fire Safety Installation Process:
          </h2>
          <ul className="space-y-3">
            <li className="flex items-start gap-3 text-lg leading-relaxed">
              <span>➤</span>
              <span>Designing a Technical Support</span>
            </li>
            <li className="flex items-start gap-3 text-lg leading-relaxed">
              <span>➤</span>
              <span>Designing a Fire Safety Plan</span>
            </li>
            <li className="flex items-start gap-3 text-lg leading-relaxed">
              <span>➤</span>
              <span>Installing Fire Alarm & Detection Systems</span>
            </li>
            <li className="flex items-start gap-3 text-lg leading-relaxed">
              <span>➤</span>
              <span>
                Commissioning Fire Detection Systems, Alarm System and Fire
                Extinguishing System
              </span>
            </li>
            <li className="flex items-start gap-3 text-lg leading-relaxed">
              <span>➤</span>
              <span>Testing, Training & Maintenance</span>
            </li>
          </ul>
        </div>
      </div>


      {/* Video Play Button */}
      {/* <div className="absolute right-6 top-16 md:right-12 md:top-20 transform -translate-y-1/2 z-20">
        <button
          onClick={() => setIsVideoOpen(true)}
          className="w-16 md:w-20 h-16 md:h-20 bg-green-600 rounded-full flex items-center justify-center shadow-lg hover:bg-green-700 transition-transform duration-300"
        >
          <span className="text-white text-3xl group-hover:scale-110 transition-transform">➤</span>
        </button>
      </div> */}

      {/* Video Modal */}
      {/* {isVideoOpen && (
        <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50">
          <div className="relative w-11/12 md:w-3/4 lg:w-1/2">
            
            <video
              controls
              autoPlay
              className="w-full rounded-lg shadow-lg"
            >
              <source src={N3060} type="video/mp4" />
              Your browser does not support the video tag.
            </video>

            <button
              onClick={() => setIsVideoOpen(false)}
              className="absolute -top-4 -right-4 bg-green-600 text-white w-10 h-10 rounded-full flex items-center justify-center hover:bg-red-700"
            >
              ✕
            </button>
          </div>
        </div>
      )} */}
    </div>
  );
};

export default FireSafetySection;
